import { Box, Button, Container, Flex, Heading, Spinner, Text } from "@radix-ui/themes"
import React, { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router"
import TransactionService from "../../core/services/TransactionService"
import useFetch from "../../core/hooks/useFetch"
import { ITransaction } from "../../core/types/services-types/transaction-types"
import moment from "moment"
import { ArrowTopRightIcon } from "@radix-ui/react-icons"
import {ROUTES} from '../../routes/constants'
import {useAppSelector} from '../../core/store/index'
import { IUser } from "../../core/types/services-types/user-types"
export default function Transaction() {
    const {id} = useParams()
    const navigate = useNavigate()
    const [transaction, setTransaction] = useState<ITransaction>()
    const [user, setUser] = useState<IUser>()
    const userStore = useAppSelector(store => store.user)
    const [fetchTransaction, isLoading, error, errors] = useFetch(async () => {
        if(id) {
        const data = await TransactionService.Get(id)
        setTransaction(data)
        }
    })

    const pay = () => {
        if(transaction) {
        navigate(ROUTES.SEND_MONEYS_SITE_ROUTE + `?transaction_id=${transaction.id}`)
        }
    }

    useEffect(() => {
        fetchTransaction()
    }, [])
    useEffect(() => {
        setUser(userStore.user)
    }, [userStore])
    return (
        <Container className="p-5 bg-zinc-100 min-h-[100vh]">
            { !transaction ? <Spinner /> :
            <Container className="bg-zinc-50 shadow-lg p-10 rounded-lg">
            <Container className="heading-transaction mb-5">
                <Flex align={'center'} justify={'between'}> 
                <Heading size={'5'}>
                   {transaction.type_transaction}
                </Heading>
                {
                    transaction.status === 'success' ? 
                    <Box className="p-5 rounded-lg" style={{backgroundColor: 'green'}}>
                      <Text style={{color: 'white'}}> Успешно </Text>
                    </Box>
                    :
                    transaction.status === 'cancel' ?
                    <Box className="p-5 rounded-lg" style={{backgroundColor: 'red'}}>
                    <Text style={{color: 'white'}}> Отменена </Text>
                 </Box>
                    :
                    <Box className="p-5 rounded-lg" style={{backgroundColor: 'orange'}}>
                   <Text style={{color: 'white'}}> Создано </Text>
                </Box>
                }
                </Flex>
                <hr />
            </Container>
            <Container className="data-container">

                <Container className="p-3">
                    <Text>
                    <Text weight={'bold'} color="gray"> ID Транзакции: </Text> {transaction.id}
                    </Text>
                </Container>
                <hr />
                <Container className="p-3">
                    <Text>
                    <Text weight={'bold'} color="gray"> Внешний ID Транзакции: </Text> {transaction.id_kassa_transaction}
                    </Text>
                </Container>
                <hr />
                <Container className="p-3">
                    <Text>
                    <Text weight={'bold'} color="gray"> Отправитель </Text>: {transaction.sender.login}
                    </Text>
                </Container>
                <hr />
                <Container className="p-3">
                    <Text>
                    <Text weight={'bold'} color="gray">Тип:</Text> {transaction.type_transaction}
                    </Text>
                </Container>
                <hr />
                <Container className="p-3">
                    <Text>
                    <Text weight={'bold'} color="gray"> Валюта: </Text> {transaction.currency}
                    </Text>
                </Container>
                <hr />
                <Container className="p-3">
                    <Text>
                    <Text weight={'bold'} color="gray">  Комиссия: </Text> {transaction.fee}
                    </Text>
                </Container>
                <hr />
                <Container className="p-3">
                    <Text>
                    <Text weight={'bold'} color="gray"> Количество: </Text> {transaction.amount}
                    </Text>
                </Container>
                <hr />
                <Container className="p-3">
                    <Text>
                    <Text weight={'bold'} color="gray"> Сообщение: </Text> {transaction.message}
                    </Text>
                </Container>
                <hr />
                <Container className="p-3">
                    <Text>
                    <Text weight={'bold'} color="gray"> Куда: </Text> {transaction.receiver ? transaction.receiver.login : transaction.to}
                    </Text>
                </Container>
                <hr />
                <Container className="p-3">
                    <Text>
                    <Text weight={'bold'} color="gray"> Статус: </Text> {transaction.status === 'success' ? <Text color="grass">Успешно</Text> : transaction.status === 'cancel' ? <Text color="orange">Отменена</Text> : <Text color="orange">Создано</Text>}
                    </Text>
                </Container>
                <hr />
                <Container className="p-3">
                    <Text>
                    <Text weight={'bold'} color="gray"> Создано: </Text> {moment(transaction.createdAt).format('DD:MM:YYYY HH:mm')}
                    </Text>
                </Container>
                <hr />
                <Container className="p-3">
                    <Text>
                    <Text weight={'bold'} color="gray"> Обновлено: </Text> {moment(transaction.updatedAt).format('DD:MM:YYYY HH:mm')}
                    </Text>
                </Container>
                <hr />
                <Container className="actions pt-5">
                { transaction.status === 'created' && user && transaction.user_id === user.id ?
                <Button variant='classic' onClick={() => pay()}>
                    Оплатить <ArrowTopRightIcon />
                </Button>
                :
                ''
                }
                </Container>
            </Container>
            </Container>
            }
        </Container>
    )
}